// Total slots in the Pioneros Fundadores showcase. Matches the
// "3333 Games" brand — every slot eventually maps to one selected
// creator. The page is currently a placeholder; slot-to-creator
// assignment is a future-phase concern.
export const FOUNDERS_TOTAL = 3333;

// Total slots in the Prepioneros showcase: the 500K+ people who signed
// up (WhatsApp) to join the Debook launch. Placeholder only — no backend
// yet. Too many to render at once, so the grid loads in chunks.
export const PREPIONEERS_TOTAL = 500_000;
